(function() {
  var WIDGET_ID = "quintus-selector";
  if (document.getElementById(WIDGET_ID)) return;

  var cfg = {"enabled":true,"placement":"bottom-right","paddingRight":15,"paddingBottom":15,"fontColor":"#FFFFFF","backgroundColor":"#000000","autoRedirect":false,"defaultCurrency":"EUR","currencyOrder":["EUR","DKK","SEK","PLN","RON","CZK","BGN","HUF"],"previewOnly":false,"locales":[{"locale":"da","name":"Danish","nativeName":"Dansk"},{"locale":"de","name":"German","nativeName":"Deutsch"},{"locale":"et","name":"Estonian","nativeName":"Eesti"},{"locale":"en","name":"English","nativeName":"English"},{"locale":"es","name":"Spanish","nativeName":"Español"},{"locale":"fr","name":"French","nativeName":"Français"},{"locale":"ga","name":"Irish","nativeName":"Gaeilge"},{"locale":"it","name":"Italian","nativeName":"Italiano"},{"locale":"lt","name":"Lithuanian","nativeName":"Lietuvių"},{"locale":"lb","name":"Luxembourgish","nativeName":"Lëtzebuergesch"},{"locale":"hu","name":"Hungarian","nativeName":"Magyar"},{"locale":"nl","name":"Dutch","nativeName":"Nederlands"},{"locale":"pl","name":"Polish","nativeName":"Polski"},{"locale":"pt","name":"Portuguese (Portugal)","nativeName":"Português"},{"locale":"ro","name":"Romanian","nativeName":"Română"},{"locale":"sk","name":"Slovak","nativeName":"Slovenčina"},{"locale":"sv","name":"Swedish","nativeName":"Svenska"},{"locale":"el","name":"Greek","nativeName":"Ελληνικά"}]};
  var params = new URLSearchParams(window.location.search);
  var previewMode = params.get("quintus_preview") === "1";

  if (!cfg.enabled) return;
  if (cfg.previewOnly && !previewMode) return;

  var PREFS_KEY = "quintus_prefs";
  var DEFAULT_LOCALE_KEY = "quintus_default_locale";

  function getLocaleFromPath() {
    var match = window.location.pathname.match(/^\/([a-z]{2}(-[A-Z]{2})?)(\/|$)/);
    return match ? match[1] : null;
  }

  function getCleanReturnTo() {
    var p = new URLSearchParams(window.location.search);
    p.delete("quintus_preview");
    var search = p.toString() ? "?" + p.toString() : "";
    return window.location.pathname + search;
  }

  var _defaultLocale = (function() {
    var inPath = getLocaleFromPath();
    if (inPath === null) {
      var detected = (window.Shopify && window.Shopify.locale) || "fr";
      try { localStorage.setItem(DEFAULT_LOCALE_KEY, detected); } catch(e) {}
      return detected;
    }
    try { return localStorage.getItem(DEFAULT_LOCALE_KEY) || "fr"; } catch(e) { return "fr"; }
  })();

  function getPrefs() {
    try { return JSON.parse(localStorage.getItem(PREFS_KEY) || "{}"); } catch(e) { return {}; }
  }

  function savePrefs(locale, currency) {
    try { localStorage.setItem(PREFS_KEY, JSON.stringify({ locale: locale, currency: currency })); } catch(e) {}
  }

  function switchLanguage(locale, currency) {
    var currentCurrency = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "";
    savePrefs(locale, currentCurrency);
    var current = getLocaleFromPath();
    var path = window.location.pathname;
    if (current) path = path.replace("/" + current, "");
    if (!path.startsWith("/")) path = "/" + path;
    var cleanSearch = getCleanReturnTo().replace(window.location.pathname, "") || "";
    window.location.href = (locale && locale !== _defaultLocale ? "/" + locale : "") + path + cleanSearch;
  }

  function switchCurrency(currency) {
    var currentLocale = getLocaleFromPath() || (window.Shopify && window.Shopify.locale) || "fr";
    savePrefs(currentLocale, currency);
    var form = document.createElement("form");
    form.method = "post";
    form.action = "/localization";
    var method = document.createElement("input");
    method.type = "hidden"; method.name = "_method"; method.value = "PUT";
    var cur = document.createElement("input");
    cur.type = "hidden"; cur.name = "currency_code"; cur.value = currency;
    var ret = document.createElement("input");
    ret.type = "hidden"; ret.name = "return_to"; ret.value = getCleanReturnTo();
    form.appendChild(method); form.appendChild(cur); form.appendChild(ret);
    document.body.appendChild(form);
    form.submit();
  }

  function applyPrefs(cfg) {
    var prefs = getPrefs();
    var currentLocale = getLocaleFromPath() || (window.Shopify && window.Shopify.locale) || "fr";
    if (prefs.locale && prefs.locale !== currentLocale) {
      switchLanguage(prefs.locale);
      return true;
    }
    return false;
  }

  function autoRedirect(cfg) {
    if (!cfg.autoRedirect) return false;
    var prefs = getPrefs();
    if (prefs.locale) {
      return applyPrefs(cfg);
    }
    var browserLang = (navigator.language || "").split("-")[0].toLowerCase();
    var currentLocale = getLocaleFromPath() || (window.Shopify && window.Shopify.locale) || "fr";
    if (browserLang && browserLang !== currentLocale) {
      switchLanguage(browserLang);
      return true;
    }
    savePrefs(currentLocale, cfg.defaultCurrency);
    return false;
  }

  function getPosition(placement, paddingRight, paddingBottom) {
    var styles = { position: "fixed", zIndex: "1040" };
    if (placement === "bottom-right") {
      styles.bottom = paddingBottom + "px";
      styles.right = paddingRight + "px";
    } else if (placement === "bottom-left") {
      styles.bottom = paddingBottom + "px";
      styles.left = paddingRight + "px";
    } else if (placement === "top-right") {
      styles.top = paddingBottom + "px";
      styles.right = paddingRight + "px";
    } else {
      styles.top = paddingBottom + "px";
      styles.left = paddingRight + "px";
    }
    return styles;
  }

  function buildWidget(cfg) {
    var currentLocale = getLocaleFromPath() || (window.Shopify && window.Shopify.locale) || "fr";
    var currentCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || cfg.defaultCurrency;

    var wrapper = document.createElement("div");
    wrapper.id = WIDGET_ID;
    var pos = getPosition(cfg.placement, cfg.paddingRight, cfg.paddingBottom);
    Object.assign(wrapper.style, pos);

    var btn = document.createElement("button");
    btn.style.cssText = "display:inline-flex;align-items:center;gap:8px;padding:8px 14px;border-radius:6px;border:none;cursor:pointer;font-size:14px;font-weight:600;";
    btn.style.backgroundColor = cfg.backgroundColor;
    btn.style.color = cfg.fontColor;
    btn.innerHTML = "&#127760; " + currentCurrency + " " + currentLocale.toUpperCase() + " &#9660;";

    var dropdown = document.createElement("div");
    dropdown.style.cssText = "display:none;position:absolute;bottom:110%;right:0;background:#fff;border:1px solid #ddd;border-radius:8px;padding:10px;box-shadow:0 4px 20px rgba(0,0,0,0.15);width:280px;";

    var columns = document.createElement("div");
    columns.style.cssText = "display:flex;gap:8px;";

    var colCur = document.createElement("div");
    colCur.style.cssText = "flex:1;min-width:0;max-height:200px;overflow-y:auto;";
    var curTitle = document.createElement("div");
    curTitle.style.cssText = "font-size:10px;font-weight:700;color:#999;text-transform:uppercase;padding:0 4px 5px;border-bottom:1px solid #f0f0f0;margin-bottom:3px;position:sticky;top:0;background:#fff;";
    curTitle.textContent = "Devise";
    colCur.appendChild(curTitle);

    var currencies = cfg.currencyOrder.length ? cfg.currencyOrder : [cfg.defaultCurrency];
    currencies.forEach(function(currency) {
      var item = document.createElement("button");
      item.style.cssText = "display:block;width:100%;text-align:left;padding:4px 6px;border:none;background:" + (currency === currentCurrency ? "#f5f5f5" : "transparent") + ";border-radius:4px;cursor:pointer;font-size:12px;";
      item.textContent = currency;
      item.onclick = function() { switchCurrency(currency); };
      colCur.appendChild(item);
    });

    var colLang = document.createElement("div");
    colLang.style.cssText = "flex:1;min-width:0;max-height:200px;overflow-y:auto;";
    var langTitle = document.createElement("div");
    langTitle.style.cssText = "font-size:10px;font-weight:700;color:#999;text-transform:uppercase;padding:0 4px 5px;border-bottom:1px solid #f0f0f0;margin-bottom:3px;position:sticky;top:0;background:#fff;";
    langTitle.textContent = "Langue";
    colLang.appendChild(langTitle);

    var availableLocales = (cfg.locales && cfg.locales.length) ? cfg.locales : [];
    availableLocales.forEach(function(lang) {
      var item = document.createElement("button");
      item.style.cssText = "display:block;width:100%;text-align:left;padding:4px 6px;border:none;background:" + (lang.locale === currentLocale ? "#f5f5f5" : "transparent") + ";border-radius:4px;cursor:pointer;font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;";
      item.textContent = lang.nativeName;
      item.onclick = function() { switchLanguage(lang.locale); };
      colLang.appendChild(item);
    });

    columns.appendChild(colCur);
    columns.appendChild(colLang);
    dropdown.appendChild(columns);

    btn.onclick = function(e) {
      e.stopPropagation();
      dropdown.style.display = dropdown.style.display === "none" ? "block" : "none";
    };
    document.addEventListener("click", function() { dropdown.style.display = "none"; });

    wrapper.appendChild(dropdown);
    wrapper.appendChild(btn);
    document.body.appendChild(wrapper);
  }

  autoRedirect(cfg);
  buildWidget(cfg);

  var OFFCANVAS_IDS = ["offcanvas-cart", "offcanvas-search", "offcanvas-wishlist", "offcanvas-menu"];
  var openCount = 0;

  function setWidgetVisibility(visible) {
    var widget = document.getElementById(WIDGET_ID);
    if (widget) widget.style.visibility = visible ? "visible" : "hidden";
  }

  function bindOffcanvasEvents() {
    OFFCANVAS_IDS.forEach(function(id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener("show.bs.offcanvas", function() {
        openCount++;
        setWidgetVisibility(false);
      });
      el.addEventListener("hidden.bs.offcanvas", function() {
        openCount = Math.max(0, openCount - 1);
        if (openCount === 0) setWidgetVisibility(true);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindOffcanvasEvents);
  } else {
    bindOffcanvasEvents();
  }
})();